// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Unterhaltung',
  working: 'Ich bin dran…',
  stopped: 'Gestoppt. Es wurde nichts geändert.',
  step_stopped: 'Gestoppt',
  not_sent: 'Nicht gesendet',
  failed: {
    text: 'Bei mir ist etwas schiefgelaufen, es wurde nichts geändert. Versuch es gleich noch mal.',
    retry: 'Erneut versuchen',
  },
  question: {
    type_answer: 'Oder schreib deine Antwort unten.',
  },
  unavailable: {
    title: {
      amigo: 'Amigo ist gerade nicht verfügbar.',
      assistant: 'Der Assistent ist gerade nicht verfügbar.',
    },
    text: 'Es wurde nichts geändert, und der Rest des Dashboards funktioniert wie gewohnt. Versuch es in ein paar Minuten noch mal.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Heute',
  when: {
    today: 'Heute, {{time}}',
    yesterday: 'Gestern, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line:
    'Neuer Chat für {{restaurant}}. Die Chats von {{previous}} findest du unter Chats, wenn du zurückwechselst.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat von {{name}} (FoodAmigos)',
      owner: 'Chat von {{name}} (Inhaber)',
      staff: 'Chat von {{name}} (Mitarbeiter)',
      partner: 'Chat von {{name}} (Partner)',
      other: 'Chat von {{name}}',
      unnamed: 'Chat von jemand anderem',
    },
    text: 'Chat von {{name}}. Du kannst ihn lesen, aber nicht antworten oder seine Karten freigeben.',
    text_unnamed: 'Chat von jemand anderem. Du kannst ihn lesen, aber nicht antworten oder seine Karten freigeben.',
    new_chat: 'Neuer Chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Dieser Chat ist beendet. Starte einen neuen Chat, um weiterzumachen.',
    new_chat: 'Neuer Chat',
    moved_line: 'Neuer Chat, weil der vorige beendet war',
  },
  composer: {
    label: 'Nachricht',
    placeholder: 'Stell eine Frage oder beschreib eine Änderung',
    placeholder_answer: 'Schreib deine Antwort',
    hint: 'Enter zum Senden · Shift+Enter für eine neue Zeile',
  },
  table: {
    show_all: 'Alle {{count}} Zeilen zeigen',
    show_fewer: 'Weniger zeigen',
  },
  steps: {
    areas: 'Ich schaue, wobei ich hier helfen kann',
    area_describe: 'Ich sehe mir {{area}} an',
    read: 'Ich lese deine Daten',
    propose: 'Ich bereite die Änderung vor',
    change_set_get: 'Ich prüfe die Änderung',
    gap_record: 'Ich notiere das für unser Team',
    research: 'Ich schaue nach, wie das funktioniert',
    screen_find: 'Ich suche die richtige Seite',
    file_read: 'Ich lese deine Datei',
    shop_check: 'Ich prüfe deinen Shop',
    area_describe_other: 'Ich sehe mir diesen Bereich an',
    other: 'Ich prüfe etwas',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: 'Ich konnte die Speisekarte nicht lesen',
      hours: 'Ich konnte die Öffnungszeiten nicht lesen',
      order_settings: 'Ich konnte die Bestelleinstellungen nicht lesen',
      my_info: 'Ich konnte deine Angaben nicht lesen',
      marketing: 'Ich konnte dein Marketing nicht lesen',
      gift_cards: 'Ich konnte die Geschenkkarten nicht lesen',
      reports: 'Ich konnte deine Zahlen nicht lesen',
      other: 'Ich konnte deine Daten nicht lesen',
    },
    propose: {
      menu: 'Ich konnte die Änderung der Speisekarte nicht vorbereiten',
      hours: 'Ich konnte die Änderung der Öffnungszeiten nicht vorbereiten',
      order_settings: 'Ich konnte die Änderung der Bestelleinstellungen nicht vorbereiten',
      my_info: 'Ich konnte die Änderung deiner Angaben nicht vorbereiten',
      marketing: 'Ich konnte die Marketing-Änderung nicht vorbereiten',
      gift_cards: 'Ich konnte die Änderung der Geschenkkarten nicht vorbereiten',
      other: 'Ich konnte die Änderung nicht vorbereiten',
    },
    change_set_get: { other: 'Ich konnte die Änderung nicht prüfen' },
    research: { other: 'Ich konnte nicht nachschauen, wie das funktioniert' },
    screen_find: { other: 'Ich konnte die Seite nicht finden' },
    file_read: { other: 'Ich konnte deine Datei nicht lesen' },
    shop_check: { other: 'Ich konnte deinen Shop nicht öffnen' },
  },
  // The areas of contracts §0 as the steps name them ("Ich sehe mir {{area}} an").
  areas: {
    menu: 'die Speisekarte',
    hours: 'die Öffnungszeiten',
    order_settings: 'die Bestelleinstellungen',
    my_info: 'deine Restaurantinfos',
    marketing: 'das Marketing',
    reports: 'die Berichte',
  },
};
